/* eslint-disable no-loop-func */
import { Context } from '../types';

import { createDomElement } from './create-dom-element';
import { getManifest } from './get-manifest';

/**
 * @description Get module data from manifest file
 * @param callback on load callback
 */
export async function getModuleData(
  this: Context,
  callback: () => void,
  testPath?: string,
): Promise<unknown> {
  const { host, element, name, mainContainerRef } = this;

  try {
    // Fetch manifest file
    const manifest: any = await getManifest(host, name, testPath);

    if (this.beforeCallback) {
      this.beforeCallback(manifest);
    }

    let filesCount = 0;
    // Process the received list of names
    for (const key in manifest.files) {
      const js = key.match(/\.js/);

      // If the file format is incorrect then skip
      if (!key.match(/\.js|\.css/) || key.includes('.map')) {
        continue;
      }

      filesCount++;
      const file = `${testPath ?? host}${manifest.files[key]}`;

      const [elementType, target]: ['script' | 'link', any] = js
        ? ['script', mainContainerRef.current]
        : ['link', element.parentNode];

      createDomElement(elementType, file, () => {
        const isLastFile = !--filesCount;
        if (isLastFile) callback();
      }).add(target);
    }
    return null;
  } catch (e) {
    return e;
  }
}
